

<nav class="bg-[#444] barder border-black fixed top-0 w-full z-20">
    <div class="flex flex-wrap justify-between  items-center mx-auto p-4">
        <a class="flex items-center space-x-3 rtl:space-x-reverse">
            <span class="self-center text-2xl inline-flex gap-4 font-semibold whitespace-nowrap text-white">
                <img src="favicon.ico" alt="">SSR-CMS</span>
        </a>
        <div class="flex items-center space-x-6 rtl:space-x-reverse">
            <button (click)="logout()" class="text-white bg-[#c55a11] hover:bg-white hover:text-[#c55a11] border border-[#c55a11] font-medium rounded-lg text-sm px-5 py-2.5 text-center ">Logout</button>
        </div>
    </div>
</nav>

